goog.provide('yext.entity.fields.Folder');
goog.provide('yext.entity.fields.FolderModel');

goog.require('yext');
goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.storm.FolderTree');

/**
 * Model for the folder field
 *
 * @param {!Object} data
 * @constructor
 */
yext.entity.fields.FolderModel = function(data) {
  this.set(data);
};

/**
 * Call set and optionally triggers an update message
 *
 * @param {!Object} update
 */
yext.entity.fields.FolderModel.prototype.update = function(update) {
  if (this.set(update)) {
    this.message('updated');
  }
};

/**
 * Set values on the model, checking for changes
 *
 * @param {!Object} update
 * @return {boolean} True if the update changes the model
 */
yext.entity.fields.FolderModel.prototype.set = function(update) {
  var updated = false;
  if (yext.isString(update.folderId) && this.folderId !== update.folderId) {
    this.folderId = update.folderId;
    updated = true;
  }
  if (yext.isString(update.keyPath) && this.keyPath !== update.keyPath) {
    this.keyPath = update.keyPath;
    updated = true;
  }
  if (yext.isBoolean(update.indeterminate) && this.indeterminate !== update.indeterminate) {
    this.indeterminate = update.indeterminate;
    updated = true;
  }
  return updated;
};

/**
 * Trigger a message on the FolderModel
 *
 * @param {string} message Message to trigger
 */
yext.entity.fields.FolderModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * @param {!jQuery} $ctx
 * @constructor
 */
yext.entity.fields.Folder = function($ctx) {
  this.$ctx = $ctx;
  this.$tree = $ctx.find('.js-folder-tree-edit');
  this.$fieldValue = $ctx.find('.js-field-value');
  this.$folderContainer = $ctx.find('.js-select-folder-container');
  this.$indeterminateMsg = $ctx.find('.js-indeterminate-message');

  this.parseData();
  this.storeValues();
  this.bindSimpleFolderTree();
  this.bindControls();
  this.bindUpdates();
};

/**
 * Parse the data from DOM
 */
yext.entity.fields.Folder.prototype.parseData = function() {
  var $folderEdit = this.$ctx.find('.js-folder-edit');
  this.model = new yext.entity.fields.FolderModel({
    folderId: this.$fieldValue.val(),
    keyPath: $folderEdit.data('keyPath'),
    indeterminate: $folderEdit.data('indeterminate')});
};

/**
 * Store the values to be restored on reset
 */
yext.entity.fields.Folder.prototype.storeValues = function() {
  this.storedModel = new yext.entity.fields.FolderModel(this.model);
};

/**
 * Bind the simple folder tree plugin
 */
yext.entity.fields.Folder.prototype.bindSimpleFolderTree = function() {
  var self = this;

  this.$tree.simpleFolderTree({
    'title': yext.msg('Location Add Folders Tree'),
    'topLevelFolders': window.topLevelFolders,
    'initialKeyPath': this.model.keyPath,
    'manageFoldersPermission': false, // TODO(mattjs) Update this with correct permission
    'idPrefix': 'tree-edit-id-',
    'onActivate': function(node) {
      self.node = node;
      self.model.update({
        folderId: node.data.key,
        keyPath: self.calculateKeyPath(),
      });
    },
  });
};

/**
 * Reset the state of the folder
 */
yext.entity.fields.Folder.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Set the folder data
 *
 * @param {!Object} data
 */
yext.entity.fields.Folder.prototype.set = function(data) {
  this.model.update(data);

  this.$tree.simpleFolderTree('destroy');
  this.bindSimpleFolderTree();
};

/**
 * Bind the select and cancel controls
 */
yext.entity.fields.Folder.prototype.bindControls = function() {
  var self = this;

  this.$ctx.find('.js-select-folder').click(function() {
    if (self.node) {
      self.$ctx.find('.js-folder-view').html(self.calculateFolderName());
      self.message('folderSelected');
    }
  });

  this.$ctx.find('.js-cancel-folder-selection').click(function() {
    self.reset();
    self.message('cancelSelection');
  });

  this.$indeterminateMsg.click(function() {
    self.model.update({indeterminate: false});
    $(this).hide();
    self.$folderContainer.show();
  });
};

/**
 * Emit a message with the instance as context
 * @param {string} message The message name
 */
yext.entity.fields.Folder.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Calculate key path for the current node
 */
yext.entity.fields.Folder.prototype.calculateKeyPath = function() {
  var keys = this.getParentKeys(this.node, []);
  return keys.join('/');
};

/**
 * Get all keys up to parent by recursion
 * @param {!Object} node Current node
 * @param {!Array} keys Array for collecting values during recursion
 */
yext.entity.fields.Folder.prototype.getParentKeys = function(node, keys) {
  keys.unshift(node.data.key);
  if (node.parent && node.parent.data.key != '_1') {
    return this.getParentKeys(node.parent, keys);
  }
  return keys;
};

/**
 * Calculate the folder name using the currently selected node
 */
yext.entity.fields.Folder.prototype.calculateFolderName = function() {
  var names = this.getParentNames(this.node, []);
  return names.join(' > ');
};

/**
 * Get all names up to parent by recursion
 * @param {!Object} node Current node
 * @param {!Array} keys Array for collecting values during recursion
 */
yext.entity.fields.Folder.prototype.getParentNames = function(node, names) {
  names.unshift(node.data.title);
  if (node.parent && node.parent.data.title) {
    return this.getParentNames(node.parent, names);
  }
  return names;
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.entity.fields.Folder.prototype.bindUpdates = function() {
  var self = this;

  $(this.model).on('updated', function() {
    self.$fieldValue.val(self.model.folderId);
    self.render();
    self.message('updated');
  });
};

/**
 * Render the edit mode using the current state of the model
 */
yext.entity.fields.Folder.prototype.render = function() {
  this.$indeterminateMsg.toggle(this.model.indeterminate);
  this.$folderContainer.toggle(!this.model.indeterminate);
};

/**
 * Get the display value for the field
 *
 * @param {string} folderName Folder name
 * @return {string} A display html string
 */
yext.entity.fields.Folder.prototype.getDisplayValue = function(folderName) {
  var display = '<div class="folder-view js-folder-view">';
  if (!folderName) {
    display += yext.msg('Not in Folder');
  } else {
    display += folderName;
  }
  display += '</div>';
  return display;
};
